import {
  CuePoint,
  CuePointSettings,
  CuePointType,
  CuePointMetadata,
  CuePointSourceProperty
} from '../store/presenter-slide-management-store/presentation-config-aggregate/presentation-config-aggregate-types/presentation-config-aggregate-types';

const asPartialCuePointSourceProperty = <T extends Partial<CuePointSourceProperty[]>>(t: T) => t;
const asPartialCuePoint = <T extends Partial<CuePoint>>(t: T) => t;
const asPartialCuePointMetadata = <T extends Partial<CuePointMetadata>>(t: T) => t;

export const defaultSettingsProperties: CuePointSettings = {
  pause: false,
  zoom: 0,
  key: true,
  javascript: ''
};

export const defaultMetadataProperties = asPartialCuePointMetadata({
  title: '',
  footnote: '',
  speakerNotes: ''
});

export const defaultSourceProperties = asPartialCuePointSourceProperty([{
  name: 'step',
  value: ''
}]);

export const defaultCuePointProperties = asPartialCuePoint({
  time: 0,
  type: CuePointType.image,
});